// src/Login.js
import React, { useState } from 'react';
import HueniLogo2 from './image/HueniLogo2.png';

const Login = ({ onLogin }) => {
  const [userId, setUserId] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();

    // Predefined credentials
    const correctUserId = 'Hueni';
    const correctPassword = 'mic007';

    if (userId === correctUserId && password === correctPassword) {
      onLogin(userId); // Call the callback to update the state in App.js
    } else {
      setError('Invalid credentials. Please try again.');
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <img src={HueniLogo2} alt="Hueni Logo" className="Loginlogo" style={{ width: '100px', height: 'auto' }} />
        <h1>Hueni AI</h1>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>User ID</label>
            <input
              type="text"
              value={userId}
              onChange={(e) => setUserId(e.target.value)}
              placeholder="Enter User ID"
              required
            />
          </div>
          <div className="form-group">
            <label>Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter Password"
              required
            />
          </div>
          {error && <p className="error">{error}</p>}
          <button type="submit" className="login-button">Login</button>
        </form>
      </div>
    </div>
  );
};

export default Login;
